<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper" id="table-boxs">
      <a-spin :spinning="spinning">
        <!--        <a-tabs defaultActiveKey="0" @change="pageChange">-->
        <!--          <a-tab-pane :tab="page.name" v-for="(page,index) in pageList" :key="index+1"></a-tab-pane>-->
        <!--        </a-tabs>-->

        <div class="content_box">
          <div class="content_left">
            <a-collapse v-model="activeKey">
              <a-collapse-panel key="1" header="基础组件">
                <a-button type="primary" class="view-items" @click="typeChange('slidePics','图展')">图展</a-button>
                <a-button
                    type="primary"
                    class="view-items"
                    @click="typeChange('navButton','导航按钮')"
                >导航按钮
                </a-button>
                <a-button
                    type="primary"
                    class="view-items"
                    @click="typeChange('notice','通知公告')"
                >通知公告
                </a-button>
                <a-button type="primary" class="view-items" @click="typeChange('pic','图片')">图片</a-button>
                <a-button type="primary" class="view-items" @click="typeChange('pics2','图片')">横图(2或4张)</a-button>
                <a-button type="primary" class="view-items" @click="typeChange('pics3','图片')">横图(3张)</a-button>
                <a-button type="primary" class="view-items" @click="typeChange('pics5','图片')">组合图片(5张)</a-button>
                <a-button type="primary" class="view-items" @click="typeChange('shop','门店')">门店</a-button>
                <a-button type="primary" class="view-items" @click="typeChange('business','商家')">商家</a-button>
                <a-button
                    type="primary"
                    class="view-items"
                    @click="typeChange('goodsList0','商品(横向滚动)')"
                >商品(横向滚动)
                </a-button>
                <a-button
                    type="primary"
                    class="view-items"
                    @click="typeChange('goodsList1','商品(小图)')"
                >商品(小图)
                </a-button>
                <a-button
                    type="primary"
                    class="view-items"
                    @click="typeChange('goodsList2','商品(中图)')"
                >商品(中图)
                </a-button>
                <a-button
                    type="primary"
                    class="view-items"
                    @click="typeChange('goodsList3','商品(大图)')"
                >商品(大图)
                </a-button>
                <a-button
                    type="primary"
                    class="view-items"
                    @click="typeChange('goodsTabs1','组合列表')"
                >组合列表
                </a-button>
                <a-button
                    type="primary"
                    class="view-items"
                    @click="typeChange('dynamicList','动态列表')"
                >动态列表
                </a-button>
              </a-collapse-panel>
              <!--              <a-collapse-panel key="2" header="营销组件">-->
              <!--                <p>待开发</p>-->
              <!--              </a-collapse-panel>-->
            </a-collapse>
          </div>
          <div class="content_main" id="content_main">
            <img
                v-if="queryParam.page_id==1"
                style="width:375px"
                src="https://static.dierqudao.com/images/webViewHeader.jpg"
                alt
                srcset
            />

            <!-- <div class="content_index">

            <div  v-for="(item,index) in contentList" :key="index" class="content_class" @mousedown="onMouseDown(item)">{{ index }}</div>
            </div>-->
            <div class="color-list">
              <div
                  class="color-item"
                  v-for="(content,i) in contentList"
                  v-dragging="{ item: content, list: contentList, group: 'content' }"
                  :key="i"
                  @click="handleEdit(content,i)"
              >
                <!-- <div
                  v-if="content.type=='navButton'"
                  :style="content.styles.pic.length > 0 ? 'margin-top:'+content.styles.margin+'px;background:url('+content.styles.pic[0].url+')':'margin-top:'+content.styles.margin+'px'"
                  class="content-items"
                >-->
                <div
                    v-if="content.type=='navButton'"
                    :style="{'background':content.styles.pic.length > 0 ? 'url('+content.styles.pic[0].url+')':'','margin-top':content.styles.margin+'px','padding-top':content.styles.padding_top+'px','padding-bottom':content.styles.padding_bottom+'px','background-position':content.styles.position_status==1? 'top center':'bottom center'}"
                    class="content-items"
                >
                  <div v-if="content.status==2" class="items-close">
                    <div>用户端已隐藏显示</div>
                  </div>
                  <div class="right-close" @click="onDelete(i)">
                    <div>
                      <img
                          style="width:20px;height:20px"
                          src="https://static.dierqudao.com/images/icon-modileview-close.png"
                          alt
                          srcset
                      />
                    </div>
                  </div>
                  <NavButton :content="content.content"/>
                </div>
                <div
                    v-if="content.type=='slidePics'"
                    :style="'margin-top:'+content.styles.margin+'px'"
                    class="content-items"
                >
                  <div v-if="content.status==2" class="items-close">
                    <div>用户端已隐藏显示</div>
                  </div>
                  <div class="right-close" @click="onDelete(i)">
                    <div>
                      <img
                          style="width:20px;height:20px"
                          src="https://static.dierqudao.com/images/icon-modileview-close.png"
                          alt
                          srcset
                      />
                    </div>
                  </div>
                  <SlidePics :content="content.content"/>
                </div>
                <div
                    v-if="content.type=='notice'"
                    :style="'margin-top:'+content.styles.margin+'px'"
                    class="content-items"
                >
                  <div v-if="content.status==2" class="items-close">
                    <div>用户端已隐藏显示</div>
                  </div>
                  <div class="right-close" @click="onDelete(i)">
                    <div>
                      <img
                          style="width:20px;height:20px"
                          src="https://static.dierqudao.com/images/icon-modileview-close.png"
                          alt
                          srcset
                      />
                    </div>
                  </div>
                  <Notice :content="content.content"/>
                </div>
                <div
                    v-if="content.type=='goodsList0'"
                    :style="{'background':content.styles.pic.length > 0 ? 'url('+content.styles.pic[0].url+')':'','margin-top':content.styles.margin+'px','padding-top':content.styles.padding_top+'px','padding-bottom':content.styles.padding_bottom+'px','background-position':content.styles.position_status==1? 'top center':'bottom center'}"
                    class="content-items"
                >
                  <div v-if="content.status==2" class="items-close">
                    <div>用户端已隐藏显示</div>
                  </div>
                  <div class="right-close" @click="onDelete(i)">
                    <div>
                      <img
                          style="width:20px;height:20px"
                          src="https://static.dierqudao.com/images/icon-modileview-close.png"
                          alt
                          srcset
                      />
                    </div>
                  </div>
                  <GoodsList0
                      :content="content.content"
                      :title="content.title"
                      :row="content"
                      :styles="content.styles"
                  />
                </div>
                <div
                    v-if="content.type=='goodsList1'"
                    :style="{'background':content.styles.pic.length > 0 ? 'url('+content.styles.pic[0].url+')':'','margin-top':content.styles.margin+'px','padding-top':content.styles.padding_top+'px','padding-bottom':content.styles.padding_bottom+'px','background-position':content.styles.position_status==1? 'top center':'bottom center'}"
                    class="content-items"
                >
                  <div v-if="content.status==2" class="items-close">
                    <div>用户端已隐藏显示</div>
                  </div>
                  <div class="right-close" @click="onDelete(i)">
                    <div>
                      <img
                          style="width:20px;height:20px"
                          src="https://static.dierqudao.com/images/icon-modileview-close.png"
                          alt
                          srcset
                      />
                    </div>
                  </div>
                  <GoodsList1
                      :content="content.content"
                      :title="content.title"
                      :styles="content.styles"
                  />
                </div>
                <div
                    v-if="content.type=='goodsList2'"
                    :style="{'background':content.styles.pic.length > 0 ? 'url('+content.styles.pic[0].url+')':'','margin-top':content.styles.margin+'px','padding-top':content.styles.padding_top+'px','padding-bottom':content.styles.padding_bottom+'px','background-position':content.styles.position_status==1? 'top center':'bottom center'}"
                    class="content-items"
                >
                  <div v-if="content.status==2" class="items-close">
                    <div>用户端已隐藏显示</div>
                  </div>
                  <div class="right-close" @click="onDelete(i)">
                    <div>
                      <img
                          style="width:20px;height:20px"
                          src="https://static.dierqudao.com/images/icon-modileview-close.png"
                          alt
                          srcset
                      />
                    </div>
                  </div>
                  <GoodsList2
                      :content="content.content"
                      :title="content.title"
                      :styles="content.styles"
                  />
                </div>

                <div
                    v-if="content.type=='goodsList3'"
                    :style="{'background':content.styles.pic.length > 0 ? 'url('+content.styles.pic[0].url+')':'','margin-top':content.styles.margin+'px','padding-top':content.styles.padding_top+'px','padding-bottom':content.styles.padding_bottom+'px','background-position':content.styles.position_status==1? 'top center':'bottom center'}"
                    class="content-items"
                >
                  <div v-if="content.status==2" class="items-close">
                    <div>用户端已隐藏显示</div>
                  </div>
                  <div class="right-close" @click="onDelete(i)">
                    <div>
                      <img
                          style="width:20px;height:20px"
                          src="https://static.dierqudao.com/images/icon-modileview-close.png"
                          alt
                          srcset
                      />
                    </div>
                  </div>
                  <GoodsList3
                      :content="content.content"
                      :title="content.title"
                      :styles="content.styles"
                  />
                </div>

                <div
                    v-if="content.type=='pic'"
                    :style="'margin-top:'+content.styles.margin+'px'"
                    class="content-items"
                >
                  <div v-if="content.status==2" class="items-close">
                    <div>用户端已隐藏显示</div>
                  </div>
                  <div class="right-close" @click="onDelete(i)">
                    <div>
                      <img
                          style="width:20px;height:20px"
                          src="https://static.dierqudao.com/images/icon-modileview-close.png"
                          alt
                          srcset
                      />
                    </div>
                  </div>
                  <Pic :content="content.content" :title="content.title"/>
                </div>
                <div
                    v-if="content.type=='pics5'"
                    :style="'margin-top:'+content.styles.margin+'px'"
                    class="content-items"
                >
                  <div v-if="content.status==2" class="items-close">
                    <div>用户端已隐藏显示</div>
                  </div>
                  <div class="right-close" @click="onDelete(i)">
                    <div>
                      <img
                          style="width:20px;height:20px"
                          src="https://static.dierqudao.com/images/icon-modileview-close.png"
                          alt
                          srcset
                      />
                    </div>
                  </div>
                  <Pics5 :content="content.content" :title="content.title"/>
                </div>
                <div
                    v-if="content.type=='pics3'"
                    :style="'margin-top:'+content.styles.margin+'px'"
                    class="content-items"
                >
                  <div v-if="content.status==2" class="items-close">
                    <div>用户端已隐藏显示</div>
                  </div>
                  <div class="right-close" @click="onDelete(i)">
                    <div>
                      <img
                          style="width:20px;height:20px"
                          src="https://static.dierqudao.com/images/icon-modileview-close.png"
                          alt
                          srcset
                      />
                    </div>
                  </div>
                  <Pics3 :content="content.content" :title="content.title"/>
                </div>
                <div
                    v-if="content.type=='pics2'"
                    :style="'margin-top:'+content.styles.margin+'px'"
                    class="content-items"
                >
                  <div v-if="content.status==2" class="items-close">
                    <div>用户端已隐藏显示</div>
                  </div>
                  <div class="right-close" @click="onDelete(i)">
                    <div>
                      <img
                          style="width:20px;height:20px"
                          src="https://static.dierqudao.com/images/icon-modileview-close.png"
                          alt
                          srcset
                      />
                    </div>
                  </div>
                  <Pics2 :content="content.content" :title="content.title"/>
                </div>
                <div
                    v-if="content.type=='goodsTabs1'"
                    :style="'margin-top:'+content.styles.margin+'px'"
                    class="content-items"
                >
                  <div v-if="content.status==2" class="items-close">
                    <div>用户端已隐藏显示</div>
                  </div>
                  <div class="right-close" @click="onDelete(i)">
                    <div>
                      <img
                          style="width:20px;height:20px"
                          src="https://static.dierqudao.com/images/icon-modileview-close.png"
                          alt
                          srcset
                      />
                    </div>
                  </div>
                  <GoodsTabs1 :styles="content.styles" :content="content.content" :title="content.title"/>
                </div>
                <div
                    v-if="content.type=='business'"
                    :style="'margin-top:'+content.styles.margin+'px'"
                    class="content-items"
                >
                  <div v-if="content.status==2" class="items-close">
                    <div>用户端已隐藏显示</div>
                  </div>
                  <div class="right-close" @click="onDelete(i)">
                    <div>
                      <img
                          style="width:20px;height:20px"
                          src="https://static.dierqudao.com/images/icon-modileview-close.png"
                          alt
                          srcset
                      />
                    </div>
                  </div>
                  <BusinessList :row="content" :styles="content.styles" :content="content.content"
                                :title="content.title"/>
                </div>
                <div
                    v-if="content.type=='shop'"
                    :style="'margin-top:'+content.styles.margin+'px'"
                    class="content-items"
                >
                  <div v-if="content.status==2" class="items-close">
                    <div>用户端已隐藏显示</div>
                  </div>
                  <div class="right-close" @click="onDelete(i)">
                    <div>
                      <img
                          style="width:20px;height:20px"
                          src="https://static.dierqudao.com/images/icon-modileview-close.png"
                          alt
                          srcset
                      />
                    </div>
                  </div>
                  <BusinessList :row="content" :styles="content.styles" :content="content.content"
                                :title="content.title"/>
                </div>
                <div
                    v-if="content.type=='dynamicList'"
                    :style="'margin-top:'+content.styles.margin+'px'"
                    class="content-items"
                >
                  <div v-if="content.status==2" class="items-close">
                    <div>用户端已隐藏显示</div>
                  </div>
                  <div class="right-close" @click="onDelete(i)">
                    <div>
                      <img
                          style="width:20px;height:20px"
                          src="https://static.dierqudao.com/images/icon-modileview-close.png"
                          alt
                          srcset
                      />
                    </div>
                  </div>
                  <DynamicList :row="content" :styles="content.styles" :content="content.content"
                               :title="content.title"/>
                </div>
              </div>
            </div>
          </div>
          <div class="content_right">
            <div v-if="content_right_show">
              <a-form :form="form">
                <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="组件" hasFeedback>
                  <div v-if="formData.type=='slidePics'" class>图展</div>
                  <div v-if="formData.type=='navButton'" class>导航按钮</div>
                  <div v-if="formData.type=='notice'" class>通知公告</div>
                  <div v-if="formData.type=='pic'" class>图片</div>
                  <div v-if="formData.type=='pics2'" class>横图(2或4张)</div>
                  <div v-if="formData.type=='pics3'" class>横图(3张)</div>

                  <div v-if="formData.type=='pics5'" class>组合图片(5张)</div>

                  <div v-if="formData.type=='shop'" class>门店</div>
                  <div v-if="formData.type=='business'" class>门店</div>

                  <div v-if="formData.type=='goodsList0'" class>商品(横向滚动)</div>
                  <div v-if="formData.type=='goodsList1'" class>商品(小图)</div>
                  <div v-if="formData.type=='goodsList2'" class>商品(中图)</div>
                  <div v-if="formData.type=='goodsList3'" class>商品(大图)</div>
                  <div v-if="formData.type=='goodsTabs1'" class>组合列表</div>
                  <div v-if="formData.type=='dynamicList'" class>动态列表</div>

                </a-form-item>
                <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="名称" hasFeedback>
                  <a-input v-model="formData.name" placeholder="选填"/>
                </a-form-item>

                <a-form-item
                    :labelCol="labelCol"
                    :wrapperCol="wrapperCol"
                    label="显示标题"
                    hasFeedback
                    v-if="formData.type=='goodsList0' || formData.type=='goodsList1' || formData.type=='goodsList2' || formData.type=='goodsList3' || formData.type=='business' || formData.type=='shop' || formData.type=='dynamicList' || formData.type=='goodsTabs1'"
                >
                  <a-input v-model="formData.title" placeholder="标题将显示在页面上"/>
                </a-form-item>
                <a-form-item
                    :labelCol="labelCol"
                    :wrapperCol="wrapperCol"
                    label="显示副标题"
                    hasFeedback
                    v-if="formData.type=='dynamicList'"
                >
                  <a-input v-model="formData.stitle" placeholder="副标题将显示在标题后"/>
                </a-form-item>
                <a-form-item
                    :labelCol="labelCol"
                    :wrapperCol="wrapperCol"
                    label="标题字号"
                    hasFeedback
                    v-if="formData.type=='goodsList0' || formData.type=='goodsList1' || formData.type=='goodsList2' || formData.type=='goodsList3' || formData.type=='business' || formData.type=='dynamicList' || formData.type=='goodsTabs1' "
                >
                  <a-input v-model="formData.styles.font_size" placeholder="不选默认跟随系统字号"/>
                </a-form-item>
                <a-form-item
                    :labelCol="labelCol"
                    :wrapperCol="wrapperCol"
                    label="标题粗细"
                    hasFeedback
                    v-if="formData.type=='goodsList0' || formData.type=='goodsList1' || formData.type=='goodsList2' || formData.type=='goodsList3' || formData.type=='business' || formData.type=='dynamicList' || formData.type=='goodsTabs1' "
                >
                  <a-input v-model="formData.styles.font_weight" placeholder="字体粗细 400,500..."/>
                </a-form-item>
                <a-form-item
                    :labelCol="labelCol"
                    :wrapperCol="wrapperCol"
                    label="背景图片"
                    hasFeedback
                    v-if="formData.type=='navButton' || formData.type=='goodsList0' || formData.type=='goodsList1' || formData.type=='goodsList2' || formData.type=='goodsList3'  "
                >
                  <pic-uploader :file-list="formData.styles.pic" :numberLimit="1"/>
                  <!-- <el-color-picker v-model="formData.styles.color" @change="colorChange"></el-color-picker> -->
                </a-form-item>
                <a-form-item
                    :labelCol="labelCol"
                    :wrapperCol="wrapperCol"
                    label="右侧标题"
                    hasFeedback
                    v-if="formData.type=='goodsList0' || formData.type=='goodsList1' || formData.type=='goodsList2' || formData.type=='goodsList3'  "
                >
                  <a-input v-model="formData.more_name" placeholder="请输入右侧标题"/>
                </a-form-item>
                <a-form-item
                    :labelCol="labelCol"
                    :wrapperCol="wrapperCol"
                    label="显示右侧"
                    hasFeedback
                    v-if="formData.type=='goodsList0' || formData.type=='goodsList1' || formData.type=='goodsList2' || formData.type=='goodsList3'  "
                >
                  <r-switch
                      :formData="formData"
                      field="more_status"
                      :checkedValue="1"
                      :unCheckedValue="2"
                      checkedChildren="显示"
                      unCheckedChildren="隐藏"
                  />
                </a-form-item>
                <a-form-item
                    :labelCol="labelCol"
                    :wrapperCol="wrapperCol"
                    label="显示方向"
                    hasFeedback
                    v-if="formData.type=='navButton' || formData.type=='shop' || formData.type=='goodsList0' || formData.type=='goodsList1' || formData.type=='goodsList2' || formData.type=='goodsList3'  "
                >
                  <a-radio-group
                      name="radioGroup"
                      v-model="formData.styles.position_status"
                      @change="radioItemsChange"
                  >
                    <a-radio :value="1">顶部显示</a-radio>
                    <a-radio :value="2">底部显示</a-radio>
                  </a-radio-group>
                </a-form-item>
                <a-form-item
                    :labelCol="labelCol"
                    :wrapperCol="wrapperCol"
                    label="顶部内边距"
                    hasFeedback
                    v-if="formData.type=='navButton' || formData.type=='shop' || formData.type=='goodsList0' || formData.type=='goodsList1' || formData.type=='goodsList2' || formData.type=='goodsList3'  "
                >
                  <a-row>
                    <a-col :span="8">
                      <a-slider v-model="formData.styles.padding_top" :min="0" :max="20"/>
                    </a-col>
                    <a-col :span="4">
                      <a-input-number
                          v-model="formData.styles.padding_top"
                          :min="0"
                          :max="20"
                          style="marginLeft: 16px"
                      />
                    </a-col>
                    <a-col :span="4">
                      <span>像素</span>
                    </a-col>
                  </a-row>
                </a-form-item>
                <a-form-item
                    :labelCol="labelCol"
                    :wrapperCol="wrapperCol"
                    label="底部内边距"
                    hasFeedback
                    v-if="formData.type=='navButton' || formData.type=='shop' || formData.type=='goodsList0' || formData.type=='goodsList1' || formData.type=='goodsList2' || formData.type=='goodsList3'  "
                >
                  <a-row>
                    <a-col :span="8">
                      <a-slider v-model="formData.styles.padding_bottom" :min="0" :max="20"/>
                    </a-col>
                    <a-col :span="4">
                      <a-input-number
                          v-model="formData.styles.padding_bottom"
                          :min="0"
                          :max="20"
                          style="marginLeft: 16px"
                      />
                    </a-col>
                    <a-col :span="4">
                      <span>像素</span>
                    </a-col>
                  </a-row>
                </a-form-item>
                <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="模块间距" hasFeedback>
                  <a-row>
                    <a-col :span="8">
                      <a-slider v-model="formData.styles.margin" :min="0" :max="20"/>
                    </a-col>
                    <a-col :span="4">
                      <a-input-number
                          v-model="formData.styles.margin"
                          :min="0"
                          :max="20"
                          style="marginLeft: 16px"
                      />
                    </a-col>
                    <a-col :span="4">
                      <span>像素</span>
                    </a-col>
                  </a-row>
                </a-form-item>
                <a-form-item
                    :labelCol="labelCol"
                    :wrapperCol="wrapperCol"
                    label="标题颜色"
                    hasFeedback
                    v-if="formData.type=='goodsList0' || formData.type=='goodsList1' || formData.type=='goodsList2' || formData.type=='goodsList3'  "
                >
                  <el-color-picker v-model="formData.styles.color" @change="colorChange"></el-color-picker>
                </a-form-item>

                <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="状态" hasFeedback>
                  <r-switch
                      :formData="formData"
                      field="status"
                      :checkedValue="1"
                      :unCheckedValue="2"
                      checkedChildren="显示"
                      unCheckedChildren="隐藏"
                  />
                </a-form-item>

                <slide-pic-picker
                    :formData="formData"
                    field="content"
                    v-if="formData.type=='slidePics'"
                />
                <nav-button-picker
                    :formData="formData"
                    field="content"
                    v-if="formData.type=='navButton'"
                    @getdata="getFormData"
                />
                <notice-picker
                    :formData="formData"
                    field="content"
                    v-if="formData.type=='notice'"
                    @getdata="getFormData"
                />
                <pic-picker
                    :formData="formData"
                    field="content"
                    v-if="formData.type=='pic'"
                    @getdata="getFormData"
                />
                <pic-picker
                    :formData="formData"
                    field="content"
                    v-if="formData.type=='pics5'"
                    @getdata="getFormData"
                />
                <pic-picker
                    :formData="formData"
                    field="content"
                    v-if="formData.type=='pics3'"
                    @getdata="getFormData"
                />
                <pic-picker
                    :formData="formData"
                    field="content"
                    v-if="formData.type=='pics2'"
                    @getdata="getFormData"
                />
                <shop-list-picker
                    :formData="formData"
                    field="content"
                    v-if="formData.type=='shop'"
                    @getdata="getFormData"
                />
                <dynamic-list-picker :formData="formData" field="content" v-if="formData.type=='dynamicList'"
                                     @getdata="getFormData"/>
                <shop-list-picker
                    :formData="formData"
                    field="content"
                    v-if="formData.type=='business'"
                    @getdata="getFormData"
                />
                <goods-list-picker
                    :formData="formData"
                    field="content"
                    v-if="formData.type=='goodsList0'"
                    @getdata="getFormData"
                />
                <goods-list-picker
                    :formData="formData"
                    field="content"
                    v-if="formData.type=='goodsList1'"
                    @getdata="getFormData"
                />
                <goods-list-picker
                    :formData="formData"
                    field="content"
                    v-if="formData.type=='goodsList2'"
                    @getdata="getFormData"
                />
                <goods-list-picker
                    :formData="formData"
                    field="content"
                    v-if="formData.type=='goodsList3'"
                    @getdata="getFormData"
                />
                <goods-tabs-picker
                    :formData="formData"
                    field="content"
                    v-if="formData.type=='goodsTabs1'"
                    @getdata="getFormData"
                />


              </a-form>
            </div>

            <div v-else class="content_right_none">请先选择右边组件再来配置!</div>
          </div>
        </div>

        <div class="content_foote_btn">
          <a-button type="primary" class="btn" @click="contetAdd" :loading="spinning">保存更改</a-button>
          <!-- <a-button type="primary" class="btn">存入草稿</a-button> -->
        </div>
      </a-spin>
    </div>
    <a-modal title="提示" :visible="deleteViside" @ok="deleteOk" @cancel="deleteCancel">
      <p>删除当前选择组件,用户页面将发生变化</p>
    </a-modal>
  </a-card>
</template>

<script>
import STable from '@/components/table/'
import UEditor from '@/components/UEditor/'
import EditableCell from '@/components/EditableCell/'
import RSwitch from '@/components/RSwitch/'
import UrlPicker from '@/components/UrlPicker/'
import {
  NoticePicker,
  SlidePicPicker,
  NavButtonPicker,
  PicPicker,
  GoodsListPicker,
  ShopListPicker,
  GoodsTabsPicker, DynamicListPicker
} from '@/components/ComPicker/'
import PicUploader from '@/components/PicUploader/'
import moment from 'moment'
import {
  getPageList,
  getContentList,
  editPage,
  addPageContent,
  editPageContent,
  getContentDetail,
  setContentRank,
  deleteContent,
  contentAdd
} from '@/api/page'

import {
  NavButton,
  SlidePics,
  Notice,
  GoodsList0,
  GoodsList1,
  GoodsList2,
  GoodsList3,
  Pic,
  Pics5, Pics3,Pics2,
  GoodsTabs1, BusinessList, BusinessShopList, DynamicList
} from '@/components/MobileView/'

export default {
  name: 'NewIndexPage',
  components: {
    STable,
    EditableCell,
    RSwitch,
    PicUploader,
    UEditor,
    NoticePicker,
    SlidePicPicker,
    NavButtonPicker,
    UrlPicker,
    GoodsListPicker,
    ShopListPicker,
    PicPicker,
    NavButton,
    SlidePics,
    Notice,
    GoodsList0,
    GoodsList1,
    GoodsList2,
    GoodsList3,
    Pic, Pics5, Pics3,Pics2,
    BusinessList, BusinessShopList,
    GoodsTabs1,
    GoodsTabsPicker,
    DynamicListPicker,
    DynamicList
  },
  data() {
    return {
      activeKey: ['1'],
      spinning: false,
      content_right_show: false,
      deleteViside: false,
      visible: false,
      saveLoading: false,
      openKeys: [],
      // 查询参数
      queryParam: {
        page_id: 1
      },
      labelCol: {
        xs: {span: 24},
        sm: {span: 5}
      },
      wrapperCol: {
        xs: {span: 24},
        sm: {span: 12}
      },
      form: this.$form.createForm(this),
      mdl: {},
      // 表头
      columns: [
        {
          title: '#',
          dataIndex: 'id'
        },
        {
          title: '标题',
          dataIndex: 'title'
        },
        {
          title: '名称',
          dataIndex: 'name'
        },
        {
          title: '状态',
          dataIndex: 'status',
          scopedSlots: {customRender: 'status'}
        },
        {
          title: '类型',
          dataIndex: 'type',
          scopedSlots: {customRender: 'type'}
        },
        {
          title: '排序',
          dataIndex: 'rank',
          scopedSlots: {customRender: 'rank'}
        },
        {
          title: '更新时间',
          dataIndex: 'update_time',
          customRender: text => {
            return moment(text * 1000).format('YYYY-MM-DD HH:mm:ss')
          }
        },
        {
          table: '操作',
          dataIndex: 'action',
          width: '150px',
          scopedSlots: {customRender: 'action'}
        }
      ],
      // 加载数据方法 必须为 Promise 对象

      pageList: [],
      contentList: [],
      cateOptions: [],
      selectedRowKeys: [],
      selectedRows: [],
      formData: {
        id: 0,
        title: '',
        stitle: '',
        name: '',
        more_name: '',
        more_status: 1,
        more_url: {},
        type: 'slidePics',
        content: [],
        rank: 0,
        status: 1,
        url: {},
        styles: {
          color: '#000000',
          font_size: 13,
          font_weight: 400,
          margin: 0,
          padding_top: 0,
          padding_bottom: 0,
          position: 'top',
          position_status: 1,
          pic: []
        }
      },
      formDataIndex: -1
    }
  },
  created() {
    let that = this
    // getPageList().then(res => {
    //   this.pageList = res.data
    // })
    that.load()
  },
  mounted() {
    let that = this
    this.$dragging.$on('dragged', ({value}) => {
      let list = value.list
      list.map((item, i) => {
        console.log(that.contentList[i].type, that.contentList[i].rank)
        that.contentList[i].rank = i
      })
      console.log(value.group)
    })
  },
  methods: {
    radioItemsChange(e) {
      this.formData.styles.position_status = e.target.value
    },
    colorChange() {
      console.log(this.formData.styles.color)
      if (this.formData.styles.color == null) {
        this.formData.styles.color = '#000000'
      }
    },
    contetAdd() {
      let that = this

      console.log(this.contentList)
      let list = that.contentList
      list.map((item, i) => {
        that.contentList[i].rank = i
      })
      that.contentList.map((item, i) => {
        if (item.type == 'goodsTabs1') {
          item.content.map((con, c) => {
            if (con.hasOwnProperty('list')) {
              con.list.map((list, l) => {
                if (list.url.hasOwnProperty('type')) {
                } else {
                  item.content.splice(l, 1)
                }
              })
            } else {
              item.content.splice(c, 1)
            }
          })
          if (item.content.length == 0) {
            that.contentList.splice(i, 1)
          }
        } else {
          item.content.map((con, c) => {
            if (con.url.hasOwnProperty('type')) {
            } else {
              item.content.splice(c, 1)
            }
          })
          if (item.content.length == 0) {
            that.contentList.splice(i, 1)
          }
        }
      })
      let formData = {
        contentList: JSON.stringify(that.contentList)
      }
      that.spinning = true
      console.log(formData)
      contentAdd(formData).then(res => {
        that.load()
        // setTimeout(function () {
          that.$message.success('保存成功')
          that.spinning = false
        // }, 1 * 1000)
      })
    },
    //获取子组件传递滴值
    getFormData(data) {
      console.log(data)
      console.log(this.contentList)
      if (data.id == 0) {
        // if (this.contentList.length > 0) {
        //   if (this.contentList[this.contentList.length - 1].type == data.type) {
        //     this.contentList[this.formDataIndex.length - 1] = data
        //   } else {
        //     this.contentList.push(data)
        //   }
        // } else {
        //   this.contentList.push(data)
        // }
        this.contentList.push(data)
      } else {
        this.contentList[this.formDataIndex] = data
      }
      console.log(this.contentList)
    },
    load() {
      let that = this
      getContentList().then(res => {
        that.contentList = res.data.list
        that.queryParam.page_id = res.data.page_id
        // console.log(that.contentList)
        that.deleteViside = false
      })
    },
    //取消删除某个组件
    deleteCancel() {
      this.deleteViside = false
    },
    //确认删除某个组件
    deleteOk() {
      let that = this
      deleteContent({id: that.contentList[that.formDataIndex].id})
          .then(res => {
            that.$message.success('删除成功')
            that.load()
          })
          .catch(err => {
            that.$message.error(err.data.msg)
          })
      this.contentList.splice(this.formDataIndex, 1)
      // this.form.resetFields()
      // setTimeout(() => {
      //   that.form.setFieldsValue({ ...that.contentList[that.formDataIndex] })
      // }, 500)
      // //          self.formData = {...res.data};
      // that.formData = that.contentList[that.formDataIndex - 1] //尼玛 日期选择器有bug 必须这样赋值
      // that.formData.id = that.contentList[that.formDataIndex - 1].id
      that.deleteViside = false

    },

    // 选择组件添加
    typeChange(type, value) {
      let that = this
      this.visible = true
      this.content_right_show = true
      this.form.resetFields()
      let content = []
      switch (type) {
        case 'slidePics':
        case 'pic':
          content = [
            {
              pic: [],
              url: {},
              urlVisible: false
            }
          ]
          break

        case 'navButton':
          content = [
            {
              pic: [
                {
                  name: 'https://api.dierqudao.com/public/images/no-pic.png',
                  save_name: 'https://api.dierqudao.com/public/images/no-pic.png',
                  uid: 'https://api.dierqudao.com/public/images/no-pic.png',
                  url: 'https://api.dierqudao.com/public/images/no-pic.png'
                }
              ],
              title: '自定义',
              url: {},
              urlVisible: false
            }
          ]
          break
        case 'notice':
          content = [
            {
              name: '',
              title: '请填写公告！',
              url: {},
              urlVisible: false
            }
          ]
          break
        case 'goodsList0':
        case 'goodsList1':
        case 'goodsList2':
        case 'goodsList3':
          content = [
            {
              url: {},
              urlVisible: false
            }
          ]
          break
        case 'goodsTabs1':
          content = [
            {
              sname: "可修改",
              tagname: "可修改", list: []
            }
          ]
          break
        case 'shop':
        case 'dynamicList':
          content = []
          break
      }
      this.formData = {
        id: 0,
        title: '自定义标题(可修改)',
        stitle: '副标题(可修改)',
        name: value,
        type: type,
        page_id: that.queryParam.page_id,
        content: content,
        rank: 0,
        status: 1,
        styles: {
          color: '#000000',
          font_size: 13,
          margin: 0,
          padding_top: 0,
          padding_bottom: 0,
          position: 'top',
          pic: [],
          position_status: 1
        }
      }
      setTimeout(() => {
        that.form.setFieldsValue({...this.formData})
      })
      // if (this.formData.content.length > 0) {
      //   this.formData.content = []
      // }
      this.getFormData(this.formData)
      console.log(this.formData)
      this.$nextTick(function () {
        var content_main = document.getElementById('content_main')
        var boxs = document.getElementById('table-boxs')

        content_main.scrollTop = content_main.scrollHeight
        boxs.scrollTop = boxs.scrollHeight
      })
    },
    // 改
    handleEdit(record, i) {
      const that = this
      this.form.resetFields()
      console.log(record)
      setTimeout(() => {
        that.form.setFieldsValue({...record})
      }, 500)
      //          self.formData = {...res.data};
      that.formData = record //尼玛 日期选择器有bug 必须这样赋值
      that.formData.id = record.id
      this.formDataIndex = i
      this.content_right_show = true
      console.log(this.formData)
    },

    // 增改 处理

    pageChange(index) {
      this.queryParam.page_id = this.pageList[index - 1].id
      this.formData = {
        id: 0,
        title: '',
        name: '',
        more_name: '',
        more_status: 1,
        more_url: {},
        type: 'slidePics',
        content: [],
        rank: 0,
        status: 1,
        url: {},
        styles: {
          color: '#000000',
          font_size: 13,
          font_weight: 400,
          margin: 0,
          padding_top: 0,
          padding_bottom: 0,
          position: 'top',
          position_status: 1,
          pic: []
        }
      }
          this.load()
    },

    onRankChange(key, dataIndex, value) {
      let self = this
      setContentRank({
        id: key,
        rank: value
      })
          .then(res => {
            self.load()
          })
          .catch(err => {
            self.$message.error(err.data.msg)
          })
    },

    onDelete(i) {
      this.formDataIndex = i
      console.log(this.contentList[i])
      if (this.contentList[i].id == 0) {
        this.contentList.splice(i, 1)
      } else {
        this.deleteViside = true
      }
    },

    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    }
  },

}
</script>

<style lang="less">
.scroll-box {
  padding-bottom: 12.5px;
  width: 100%;
  display: inline;
  white-space: nowrap;
  overflow-x: scroll;
  float: left;
  overflow-y: hidden;
}

.content_right_none {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ccc;
  font-size: 24px;
}

.content_foote_btn {
  padding-top: 10px;
  display: flex;
  justify-content: center;
}

.btn {
  margin: 0 10px;
}

.items-close {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.3);
}

.items-close div {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  color: #fff;
}

.ant-collapse {
  border: none;
  width: 100%;
}

.ant-radio-button-wrapper:not(:first-child)::before {
  left: none;
}

.ant-collapse-content > .ant-collapse-content-box {
  padding: 0 !important;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.radio-group-box {
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 150px;
}

.view-items {
  width: 90%;
  height: 40px;
  border-radius: 20px !important;
  line-height: 40px;
  margin: 5px auto;
  text-align: center;
}

.content-items {
  position: relative;
  background: #fff;
  border: 1px solid #fff;
  background-size: 100% !important;
  background-repeat: no-repeat !important;
}

.right-close {
  position: absolute;
  top: 0;
  right: 0;
  width: 20px;
  height: 20px;
}

.right-close div {
  width: 20px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  display: none;
}

.color-item {
  // border: 1px solid #fff;
  cursor: move;
}

.content-items:hover {
  border: 1px dashed #ccc;
}

.content-items:hover .right-close div {
  display: flex;
}

.right-close :hover {
  border: none;
  cursor: default;
  background: rgba(0, 0, 0, 0.6);
}

.right-close :hover svg {
  background: none;
}

.color-item :hover div,
.color-item :hover img,
.color-item :hover .icon-close {
  border: none;
}

.content_index {
  position: relative;
}

.content_class {
  background: pink;
  margin-top: 5px;
  height: 30px;
  cursor: move;
  position: relative;
}

.content_box {
  display: flex;
  border: 1px solid #f8f8f8;
}

.content_left {
  width: 150px;
  background: #f8f8f8;
  display: flex;
  flex-direction: column;
  align-items: center;
  max-height: 800px;
  overflow-x: scroll;
}

.content_left .ant-radio-button-wrapper:not(:first-child)::before {
  background: none;
  left: none;
}

.content_main {
  width: 375px;
  background: rgba(235, 235, 235);
  min-height: 400px;
  margin: 0 10px;
  max-height: 800px;
  overflow-x: scroll;
}

.content_right {
  flex: 1;
  background: #f8f8f8;
  max-height: 800px;
  overflow-x: scroll;
}

.content_right .item_type {
  text-align: center;
}

.custom-tree {
  /deep/ .ant-menu-item-group-title {
    position: relative;

    &:hover {
      .btn {
        display: block;
      }
    }
  }

  /deep/ .ant-menu-item {
    &:hover {
      .btn {
        display: block;
      }
    }
  }

  /deep/ .btn {
    display: none;
    position: absolute;
    top: 0;
    right: 10px;
    width: 20px;
    height: 40px;
    line-height: 40px;
    z-index: 1050;

    &:hover {
      transform: scale(1.2);
      transition: 0.5s all;
    }
  }
}
</style>
